
import { Checkbox, CheckboxField } from '../../components/checkbox'
import { Table, TableBody, TableCell, TableRow, TableHead, TableHeader } from '../../components/table'
import { Description, Label } from '../../components/fieldset'
import { Listbox, ListboxLabel, ListboxOption } from '../../components/listbox'
import { PencilSquareIcon, XCircleIcon } from '@heroicons/react/20/solid';
import { PageInfo } from '../../components/page-info';
export function FieldSetup({ handleCheckboxChange, feedTags, productFields, showFieldsMap, toggleSelectMap, updateMapFieldAtIndex, formData, errors }) {
    const singleRows = [];
    for (let i = 0; i < feedTags.length; i += 3) {
        singleRows.push(feedTags.slice(i, i + 3));
    }
    return (
        <>
        <div className="space-y-12 sm:space-y-16">
            <div className="divide-y divide-gray-200 rounded-lg bg-white shadow-sm">
                <PageInfo info={`Control which columns you want to include in the output feed and how they are mapped against the data we hold for your products.`} />
                <div className="sm:grid sm:grid-cols-1 sm:gap-4 sm:py-2 dark:bg-zinc-900 overflow-x-auto">
                    {errors.mapped_fields && <p className="ml-4 text-red-500 text-sm mt-1 text-center">{errors.mapped_fields}</p>}
                    <Table striped className="divide-y divide-gray-300 min-w-3xl ">
                        <TableHead className="bg-zinc-100 !text-black">
                            <TableRow>
                            <TableHeader className="w-2/6"></TableHeader>
                            <TableHeader className="w-2/6"></TableHeader>
                            <TableHeader className="w-2/6"></TableHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody className="divide-y divide-gray-200">
                            {singleRows.map((group, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {group.map((item, cellIndex) => (
                                    <TableCell key={cellIndex} className={`max-w-fit`}>
                                        <CheckboxField className={`!gap-y-0 max-w-fit !gap-x-2`}>
                                            <Checkbox className="max-w-fit cursor-pointer" name={`mapping_field[${item.data_tag}]`} defaultChecked={item.is_data_tag_infeed === 1} color="green" onChange={(value) => { handleCheckboxChange(`${item.data_tag}`, value); }} disabled={item.data_tag === "id"}/>
                                            <Label className={`max-w-fit font-medium`}>{item.data_label}</Label>
                                            {!showFieldsMap[item.data_tag] && ( 
                                                <div className='flex'>
                                                    <Description className="field_label">{item.data_field_label}</Description>
                                                    { item.data_tag !== "id" && (
                                                    <PencilSquareIcon aria-hidden="true" className="size-4 shrink-0 cursor-pointer ml-1 mt-1 text-indigo-700 mx-auto" onClick={() => toggleSelectMap(item.data_tag)}></PencilSquareIcon>
                                                    )}
                                                </div>
                                            )}
                                            {showFieldsMap[item.data_tag] && (
                                            <div className='flex'>
                                                <div className="grid max-w-fit">
                                                    <Listbox name={`mapping_[${item.data_tag}]`} className="min-w-40" defaultValue="" value={formData.map_changes[item.data_tag]?.trim() ? formData.map_changes[item.data_tag] : item.data_field } onChange={(value) => { updateMapFieldAtIndex(item.data_tag, value) }}>
                                                        {Object.entries(productFields).map(([key, label]) => (
                                                            <ListboxOption key={key} value={key} className="text-sm">
                                                                <ListboxLabel>{label}</ListboxLabel>
                                                            </ListboxOption>
                                                        ))}
                                                    </Listbox>
                                                </div>
                                                <div>
                                                    <XCircleIcon aria-hidden="true" className="size-5 shrink-0 cursor-pointer ml-1 mt-2 text-red-700 " onClick={() => {toggleSelectMap(item.data_tag, "unset"); updateMapFieldAtIndex(item.data_tag, "")}}></XCircleIcon>
                                                </div>
                                                </div>
                                            )}
                                        </CheckboxField>
                                    </TableCell>
                                    ))}

                                    {/* If group has less than 3 cells, fill the empty ones */}
                                    {Array.from({ length: 3 - group.length }).map((_, emptyIndex) => (
                                        <TableCell key={`empty-${emptyIndex}`}></TableCell>
                                    ))}
                                </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        </div>
        </>
    )
}